import * as React from 'react'
import { Button } from './Button'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ButtonExamples = () => {
  return (
    <div className="ButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <Button />
      </Provider>
    </div>
  )
}
